/**
 * Tetris renderer (C). Draws an engine state onto a 128×160 2D context:
 * the 10×20 well on the left, the next-piece panel on the right. No text.
 */
import {
    COLS, ROWS, CELL, BOARD_WIDTH, WIDTH, HEIGHT, PIECES, SHAPES, pieceCells,
} from './tetrisEngine';

export const COLORS = {
    background: '#000000',
    frame: '#606060',
    flash: '#ffffff',
    cells: {
        I: '#00f0f0', O: '#f0f000', T: '#a000f0', S: '#00f000', Z: '#f00000', J: '#0000f0', L: '#f0a000',
    },
};

const PANEL_X = BOARD_WIDTH + 8;
const PANEL_Y = 8;
const PANEL_W = 32;
const PANEL_H = 24;

function cellColor(value) {
    return COLORS.cells[PIECES[value - 1]] || COLORS.flash;
}

function drawBlock(ctx, px, py, color) {
    ctx.fillStyle = color;
    ctx.fillRect(px, py, CELL - 1, CELL - 1);
}

function drawPreview(ctx, type) {
    if (!type || !SHAPES[type]) {
        return;
    }
    const cells = SHAPES[type][0];
    const xs = cells.map(c => c[0]);
    const ys = cells.map(c => c[1]);
    const minX = Math.min(...xs);
    const minY = Math.min(...ys);
    const w = (Math.max(...xs) - minX + 1) * CELL;
    const h = (Math.max(...ys) - minY + 1) * CELL;
    const ox = PANEL_X + Math.floor((PANEL_W - w) / 2) - minX * CELL;
    const oy = PANEL_Y + Math.floor((PANEL_H - h) / 2) - minY * CELL;
    cells.forEach(([cx, cy]) => drawBlock(ctx, ox + cx * CELL, oy + cy * CELL, COLORS.cells[type]));
}

export function render(ctx, state, frame = 0) {
    ctx.fillStyle = COLORS.background;
    ctx.fillRect(0, 0, WIDTH, HEIGHT);

    // well edge + preview frame
    ctx.fillStyle = COLORS.frame;
    ctx.fillRect(BOARD_WIDTH, 0, 1, HEIGHT);
    ctx.fillRect(PANEL_X - 2, PANEL_Y - 2, PANEL_W + 4, 1);
    ctx.fillRect(PANEL_X - 2, PANEL_Y + PANEL_H + 1, PANEL_W + 4, 1);
    ctx.fillRect(PANEL_X - 2, PANEL_Y - 2, 1, PANEL_H + 4);
    ctx.fillRect(PANEL_X + PANEL_W + 1, PANEL_Y - 2, 1, PANEL_H + 4);

    const flashOn = frame % 4 < 2;
    for (let row = 0; row < ROWS; row += 1) {
        const clearing = state.clearingRows && state.clearingRows.includes(row);
        for (let col = 0; col < COLS; col += 1) {
            const value = state.board[row * COLS + col];
            if (value) {
                const color = clearing && flashOn ? COLORS.flash : cellColor(value);
                drawBlock(ctx, col * CELL, row * CELL, color);
            }
        }
    }

    if (state.piece) {
        const color = COLORS.cells[state.piece.type];
        pieceCells(state.piece).forEach(([bx, by]) => {
            if (by >= 0) {
                drawBlock(ctx, bx * CELL, by * CELL, color);
            }
        });
    }

    drawPreview(ctx, state.next);
}
